module.exports = "<div class=\"stepnumber\" pTooltip=\"{{name}}\"\n     tooltipPosition=\"top\">\n  {{number}}\n</div>\n"